import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LocaleContextProvider } from "../../context/LocaleContext";
import { WrapperEventPageRoute } from "../EventPage";
// import "./style.scss";
import { PlayerContextProvider } from "../../context/PlayerContext";
import { WidgetContextProvider } from "../../context/WidgetContextProvider";
import { withSentryReactRouterV6Routing } from "@sentry/react";

const SentryRoutes = withSentryReactRouterV6Routing(Routes);

export default () => {
    return (
        <Router>
            <SentryRoutes>
                <Route path={'*'} element={<Main />} />
            </SentryRoutes>
        </Router>
    );
};

const Main = () => (
    <WidgetContextProvider>
        <LocaleContextProvider>
            <PlayerContextProvider>
                <WrapperEventPageRoute />
            </PlayerContextProvider>
        </LocaleContextProvider>
    </WidgetContextProvider>
)
